export const germanFlashcards = {
  categories: [
    {
      de: "Hallo",
      rm: "Ha-lo",
      en: "Hello",
    },
    {
      de: "Guten Morgen",
      rm: "Goo-ten Mor-gen",
      en: "Good morning",
    },
    {
      de: "Guten Tag",
      rm: "Goo-ten Tahk",
      en: "Good day / Hello",
    },
    {
      de: "Guten Abend",
      rm: "Goo-ten Ah-bent",
      en: "Good evening",
    },
    {
      de: "Gute Nacht",
      rm: "Goo-te Nahkt",
      en: "Good night",
    },
    {
      de: "Tschüss",
      rm: "Chuss",
      en: "Goodbye (informal)",
    },
    {
      de: "Auf Wiedersehen",
      rm: "Auf Vee-der-zeh-en",
      en: "Goodbye (formal)",
    },
    {
      de: "Bis bald",
      rm: "Bis Bahlt",
      en: "See you soon",
    },
    {
      de: "Bitte",
      rm: "Bi-te",
      en: "Please / You're welcome",
    },
    {
      de: "Danke",
      rm: "Dahn-ke",
      en: "Thank you",
    },
    {
      de: "Vielen Dank",
      rm: "Fee-len Dahnk",
      en: "Thank you very much",
    },
    {
      de: "Gern geschehen",
      rm: "Gern geh-sheh-en",
      en: "You're welcome",
    },
    {
      de: "Entschuldigung",
      rm: "Ent-shul-di-gung",
      en: "Excuse me / Sorry",
    },
    {
      de: "Ja",
      rm: "Yah",
      en: "Yes",
    },
    {
      de: "Nein",
      rm: "Nine",
      en: "No",
    },
    {
      de: "Okay",
      rm: "O-kay",
      en: "Okay",
    },
    {
      de: "Ich verstehe nicht",
      rm: "Ikh fer-shteh-e nikht",
      en: "I don't understand",
    },
    {
      de: "Sprechen Sie Englisch?",
      rm: "Shpreh-en Zee Eng-lish?",
      en: "Do you speak English? (formal)",
    },
    {
      de: "Sprichst du Englisch?",
      rm: "Shprikst Doo Eng-lish?",
      en: "Do you speak English? (informal)",
    },
    {
      de: "Wie geht es Ihnen?",
      rm: "Vee gate es Ee-nen?",
      en: "How are you? (formal)",
    },
    {
      de: "Wie geht es dir?",
      rm: "Vee gate es Deer?",
      en: "How are you? (informal)",
    },
    {
      de: "Wie geht's?",
      rm: "Vee gates?",
      en: "How's it going?",
    },
    {
      de: "Mir geht es gut, danke",
      rm: "Meer gate es goot, dahn-ke",
      en: "I'm fine, thank you",
    },
    {
      de: "Wie heißen Sie?",
      rm: "Vee high-sen Zee?",
      en: "What's your name? (formal)",
    },
    {
      de: "Wie heißt du?",
      rm: "Vee heist Doo?",
      en: "What's your name? (informal)",
    },
    {
      de: "Ich heiße...",
      rm: "Ikh high-se...",
      en: "My name is...",
    },
    {
      de: "Wo ist...?",
      rm: "Vo ist...?",
      en: "Where is...?",
    },
    {
      de: "Wo ist die Toilette?",
      rm: "Vo ist dee To-i-le-te?",
      en: "Where is the toilet?",
    },
    {
      de: "Wo ist der Bahnhof?",
      rm: "Vo ist der Bahn-hof?",
      en: "Where is the train station?",
    },
    {
      de: "Wo ist der Flughafen?",
      rm: "Vo ist der Floog-ha-fen?",
      en: "Where is the airport?",
    },
    {
      de: "Was kostet das?",
      rm: "Vahs kos-tet dahs?",
      en: "How much does it cost?",
    },
    {
      de: "Das ist zu teuer",
      rm: "Dahs ist tsoo toy-er",
      en: "That's too expensive",
    },
    {
      de: "Hilfe!",
      rm: "Hil-fe!",
      en: "Help!",
    },
    {
      de: "Ich brauche Hilfe",
      rm: "Ikh brow-he Hil-fe",
      en: "I need help",
    },
    {
      de: "Ich habe mich verirrt",
      rm: "Ikh ha-be mikh fer-irt",
      en: "I am lost",
    },
    {
      de: "Ich suche...",
      rm: "Ikh zoo-he...",
      en: "I'm looking for...",
    },
    {
      de: "Ich möchte...",
      rm: "Ikh mökh-te...",
      en: "I would like...",
    },
    {
      de: "Ich will...",
      rm: "Ikh vill...",
      en: "I want...",
    },
    {
      de: "Einen Kaffee, bitte",
      rm: "Ai-nen Kah-fay, bi-te",
      en: "A coffee, please",
    },
    {
      de: "Die Rechnung, bitte",
      rm: "Dee Rehk-nung, bi-te",
      en: "The bill, please",
    },
    {
      de: "Ich bin Vegetarier/in",
      rm: "Ikh bin Ve-ge-ta-ree-er/in",
      en: "I am vegetarian (male/female)",
    },
    {
      de: "Ich bin allergisch gegen...",
      rm: "Ikh bin a-ler-gish geh-gen...",
      en: "I am allergic to...",
    },
    {
      de: "Das ist lecker",
      rm: "Dahs ist leh-ker",
      en: "That's delicious",
    },
    {
      de: "Prost!",
      rm: "Prohst!",
      en: "Cheers!",
    },
    {
      de: "Ich fühle mich nicht gut",
      rm: "Ikh foo-le mikh nikht goot",
      en: "I don't feel well",
    },
    {
      de: "Wo ist das Krankenhaus?",
      rm: "Vo ist dahs Kran-ken-house?",
      en: "Where is the hospital?",
    },
    {
      de: "Ich spreche ein bisschen Deutsch",
      rm: "Ikh shpreh-e ain biss-hen Doich",
      en: "I speak a little German",
    },
    {
      de: "Bitte sprechen Sie langsamer",
      rm: "Bi-te shpreh-en Zee lahk-zah-mer",
      en: "Please speak slower (formal)",
    },
    {
      de: "Kannst du das wiederholen?",
      rm: "Kahnst Doo dahs vee-der-ho-len?",
      en: "Can you repeat that? (informal)",
    },
    {
      de: "Ich bin müde",
      rm: "Ikh bin moo-de",
      en: "I am tired",
    },
    {
      de: "Wie ist das Wetter?",
      rm: "Vee ist dahs Ve-ter?",
      en: "What's the weather like?",
    },
    {
      de: "Das Wetter ist schön",
      rm: "Dahs Ve-ter ist shön",
      en: "The weather is nice",
    },
    {
      de: "Es ist heiß",
      rm: "Es ist hais",
      en: "It's hot",
    },
    {
      de: "Es ist kalt",
      rm: "Es ist kahlt",
      en: "It's cold",
    },
    {
      de: "Es regnet",
      rm: "Es reg-net",
      en: "It's raining",
    },
    {
      de: "Einverstanden",
      rm: "Ain-fer-shtahn-den",
      en: "Agreed / Okay",
    },
    {
      de: "Ich bin nicht einverstanden",
      rm: "Ikh bin nikht ain-fer-shtahn-den",
      en: "I disagree",
    },
    {
      de: "Das ist interessant",
      rm: "Dahs ist in-teh-re-sahnt",
      en: "That's interesting",
    },
    {
      de: "Das ist wichtig",
      rm: "Dahs ist vikht-ish",
      en: "That's important",
    },
    {
      de: "Das ist möglich",
      rm: "Dahs ist mög-lish",
      en: "That's possible",
    },
    {
      de: "Das ist unmöglich",
      rm: "Dahs ist oon-mög-lish",
      en: "That's impossible",
    },
    {
      de: "Wie spät ist es?",
      rm: "Vee shpate ist es?",
      en: "What time is it?",
    },
    {
      de: "Heute",
      rm: "Hoy-te",
      en: "Today",
    },
    {
      de: "Morgen",
      rm: "Mor-gen",
      en: "Tomorrow",
    },
    {
      de: "Gestern",
      rm: "Ges-tern",
      en: "Yesterday",
    },
    {
      de: "Jetzt",
      rm: "Yetst",
      en: "Now",
    },
    {
      de: "Später",
      rm: "Shpay-ter",
      en: "Later",
    },
    {
      de: "Rechts",
      rm: "Rehkhts",
      en: "Right",
    },
    {
      de: "Links",
      rm: "Linkks",
      en: "Left",
    },
    {
      de: "Geradeaus",
      rm: "Geh-rah-deh-aus",
      en: "Straight ahead",
    },
    {
      de: "Nah",
      rm: "Nah",
      en: "Near",
    },
    {
      de: "Weit",
      rm: "Vaight",
      en: "Far",
    },
    {
      de: "Ich bin verloren",
      rm: "Ikh bin fer-lo-ren",
      en: "I am lost",
    },
    {
      de: "Mir ist schlecht",
      rm: "Meer ist shleht",
      en: "I feel sick",
    },
    {
      de: "Es ist dringend",
      rm: "Es ist dring-ent",
      en: "It's urgent",
    },
    {
      de: "Einen Moment, bitte",
      rm: "Ai-nen Mo-ment, bi-te",
      en: "One moment, please",
    },
    {
      de: "Ich weiß nicht",
      rm: "Ikh vais nikht",
      en: "I don't know",
    },
    {
      de: "Alles in Ordnung",
      rm: "Ah-les in Ordt-nung",
      en: "Everything is okay",
    },
    {
      de: "Kein Problem",
      rm: "Kine Pro-blehm",
      en: "No problem",
    },
    {
      de: "Vorsicht!",
      rm: "For-zikht!",
      en: "Be careful!",
    },
    {
      de: "Lass mich in Ruhe",
      rm: "Lahs mikh in Roo-e",
      en: "Leave me alone",
    },
    {
      de: "Ich habe Hunger",
      rm: "Ikh ha-be Hung-er",
      en: "I'm hungry",
    },
    {
      de: "Ich habe Durst",
      rm: "Ikh ha-be Durst",
      en: "I'm thirsty",
    },
    {
      de: "Es tut mir sehr leid",
      rm: "Es toot meer zehr laight",
      en: "I'm very sorry",
    },
    {
      de: "Herzlichen Glückwunsch!",
      rm: "Herts-li-hen Glük-vunsh!",
      en: "Congratulations!",
    },
    {
      de: "Viel Glück!",
      rm: "Feel Glük!",
      en: "Good luck!",
    },
    {
      de: "Gute Reise!",
      rm: "Goo-te Rai-ze!",
      en: "Have a good trip!",
    },
    {
      de: "Zum Wohl!",
      rm: "Tsoom Vole!",
      en: "Cheers!",
    },
    {
      de: "Ist das kostenlos?",
      rm: "Ist dahs kos-ten-los?",
      en: "Is it free?",
    },
    {
      de: "Wie ist das WLAN-Passwort?",
      rm: "Vee ist dahs Vay-Lan-Pahs-vort?",
      en: "What's the wifi password?",
    },
    {
      de: "Darf ich ein Foto machen?",
      rm: "Darf ikh ain Fo-to mah-hen?",
      en: "May I take a picture?",
    },
  ],
};
